import { forwardRef } from 'react';

import { css, cx, splitResponsiveVariant } from '@/styled-system/css';

import { carouselSlideStyles } from './styles/carousel-slide.styles';
import type { CarouselSlidePropsInterface } from './types/carousel-slide.types';

export const CarouselSlide = forwardRef<HTMLLIElement, CarouselSlidePropsInterface>(
  (props: CarouselSlidePropsInterface, forwardedRef) => {
    const { className, css: cssProp, slideAlign = 'start', ...rest } = props;

    const responsiveSlideAlign = splitResponsiveVariant('slideAlign', slideAlign);

    const styles = css(carouselSlideStyles.raw({ ...responsiveSlideAlign }), cssProp);

    return (
      <li
        ref={forwardedRef}
        data-c11n-version={__C11N_VERSION__}
        data-c11n-component="Carousel.Slide"
        className={cx('c11n', styles, className)}
        {...rest}
      />
    );
  },
);

CarouselSlide.displayName = 'Carousel.Slide';
